import React, { useEffect, useState } from "react";
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";
import Loader from "../common/Loader";

const Optimization = () => {
	const [status, setStatus] = useState({ onOff: "NA", loading: false });

	useEffect(() => {
		const controller = new AbortController();

		api.get("/home/status", { signal: controller.signal })
			.then((response) => {
				setStatus({ onOff: response.data.optimization, loading: false });
			})
			.catch((error) => {
				if (error.name !== "CanceledError") {
					toast.error("API error getting optimization status");
				}
			});

		return () => controller.abort();
	}, []);

	const switchOptimization = async () => {
		const previousValue = status.onOff;
		setStatus({ onOff: previousValue, loading: true });

		try {
			const response = await api.post("/home/update-status", {
				optimization: !previousValue,
			});

			setStatus({
				onOff: response.status === 200 ? !previousValue : previousValue,
				loading: false,
			});
		} catch {
			setStatus({ onOff: previousValue, loading: false });
			toast.error("API error updating optimization state");
		}
	};

	const isReady = status.onOff !== "NA";
	const isOn = status.onOff === true;

	return (
		<div className="animated flipInY col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button
				id="optimization"
				className="tile-stats tile-stats--interactive optimization-card"
				type="button"
				onClick={switchOptimization}
				disabled={!isReady || status.loading}
				aria-pressed={isOn}
			>
				<h3>Optimization</h3>
				{!isReady ? (
					<div className="optimization-card__loading"><Loader size={20} /></div>
				) : (
					<div className="optimization-card__state">
						<strong>{isOn ? "ON" : "OFF"}</strong>
						<span className="tile-action" aria-hidden="true">
							<span className={`optimization-switch${isOn ? " optimization-switch--on" : ""}`}>
								<span />
							</span>
						</span>
					</div>
				)}
			</button>
		</div>
	);
};

export default Optimization;
